import { IndicatorsDashboard } from "@/components/indicadores/IndicatorsDashboard";

export default function IndicatorsPage() {
  return <IndicatorsDashboard />;
}